<template>
  <v-layout align-content-start row wrap justify-start>
    <v-flex xs12>
      <v-layout class="section-header" row wrap align-content-center justify-center>
        <v-flex xs12 md4>
          <v-layout row wrap align-center>
            <h1 class="section-title">
              <v-icon color="deep-orange darken-2">fal fa-headset</v-icon>
              Suporte
            </h1>
          </v-layout>
        </v-flex>
        <v-flex xs12 md8>
          <v-layout row wrap justify-end>
            <v-btn round depressed large color="success" dark
              v-modal-trigger="'userNewTicket'">
              Novo ticket
              <v-icon small right>fal fa-plus-circle</v-icon>
            </v-btn>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-flex>

    <user-new-ticket></user-new-ticket>

    <section>
      <p class="section-filters">
        <span class="filter-title">Filtros:</span>
        <span v-bind:class="{ active: currentFilter == 'all' }"
          @click="filterBy('all')">Todos</span>  |
        <span v-bind:class="{ active: currentFilter == 'open' }"
          @click="filterBy('open')">Em aberto</span>  |
        <span v-bind:class="{ active: currentFilter == 'closed' }"
          @click="filterBy('closed')">Resolvido</span>
      </p>
    </section>

    <empty-alert :icon="'headset'" :color="'orange accent-4'" v-if="!tickets.length">
      <div slot="content">
        <p><strong>Nenhum ticket encontrado.</strong></p>
      </div>
    </empty-alert>

    <v-flex xs12 class="section-box" v-if="tickets.length">
      <v-data-table
        width="100%"
        :headers="headers"
        :items="tickets"
        :search="search"
        sort-icon="fal fa-arrow-down"
        hide-actions
      >
        <template slot="items" slot-scope="props">
          <td>
            <router-link :to="{ name: 'AdminTicketShow', params: { id: props.item._id }}">
              {{ props.item.subject }}
            </router-link>
          </td>
          <td>{{ props.item.created_at | moment('from', 'now') }}</td>
          <td>{{ props.item.updated_at | moment('from', 'now') }}</td>
          <td>
            <status-label v-if="props.item" :status="props.item.status"></status-label>
          </td>
          <td class="align-center text-xs-right">
            <v-btn @click.stop="resolve(props.item)" round depressed color="success"
              v-if="props.item.status && props.item.status == 'open'" small outline>
              <v-tooltip bottom>
                <v-icon slot="activator" small>fal fa-check</v-icon>
                <span>Marcar como resolvido</span>
              </v-tooltip>
            </v-btn>
          </td>
        </template>
        <template slot="no-results">
          <v-alert :value="true" color="black" outline>
            Nenhum ticket encontrado.
          </v-alert>
        </template>
        <template slot="no-data">
          <div class="my-3 text-xs-center">
            Nenhum ticket encontrado.
          </div>
        </template>
      </v-data-table>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from 'axios'
import EventBus from '@/event-bus'
import router from '@/router'
import UserNewTicket from '@/components/user/support/UserNewTicket'
import AdminTicketStatusLabel from '@/components/admin/support/AdminTicketStatusLabel'

export default {
  data: () => ({
    currentUser: JSON.parse(localStorage.getItem('currentUser')),
    search: '',
    router: router,
    currentFilter: 'all',
    headers: [
      { text: 'Assunto', value: 'subject' },
      { text: 'Data de abertura', value: 'created_at', width: '200' },
      { text: 'Última atividade', value: 'updated_at', width: '200' },
      { text: 'Status', value: 'status', width: '200' },
      { text: '', value: '', sortable: false, width: '50' }
    ],
    tickets: []
  }),

  methods: {
    filterBy (filter) {
      this.currentFilter = filter

      if (filter === 'all') {
        this.loadTickets()
      } else {
        this.loadTickets(filter)
      }
    },

    loadTickets (status = '') {
      EventBus.$emit('appLoading', true)
      let path

      if (status) {
        // eslint-disable-next-line
        path = `${API.userTickets}/users/${this.currentUser._id}?status=${status}`
      } else {
        // eslint-disable-next-line
        path = `${API.userTickets}/users/${this.currentUser._id}`
      }

      axios.get(path).then(response => {
        this.tickets = response.data.tickets
        EventBus.$emit('appLoading', false)
      }).catch(errors => {
        EventBus.$emit('showSnackbar', { message: 'Erro ao carregar os tickets', color: 'error' })
        EventBus.$emit('appLoading', false)
      })
    },

    resolve (ticket) {
      ticket.status = 'closed'

      // eslint-disable-next-line
      axios.put(`${API.userTickets}/${ticket._id}`, ticket).catch(errors => {
        EventBus.$emit('showSnackbar', {
          message: 'Erro ao fechar o ticket',
          color: 'error'
        })
      })
    }
  },

  beforeDestroy () {
    EventBus.$off('loadTickets')
  },

  created () {
    this.loadTickets()
    EventBus.$on('loadTickets', this.loadTickets)
  },

  components: {
    'user-new-ticket': UserNewTicket,
    'status-label': AdminTicketStatusLabel
  }
}
</script>



// WEBPACK FOOTER //
// src/components/user/UserSupport.vue